import BookItem from "../common/bookItem";
import VisibleSwitchTranslateChild from "./visible_switch_translate_child";
export default class VisibleSwitchTranslate extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        // this.canSeeAns = false;
        this.connectNumber = this.el.connectNumber;
        this.notFirstFrame = this.el.notFirstFrame;
        this.openframe;
        // 1 true 2 false
        if (this.notFirstFrame) {
            this.openframe = 1;
        }
        else {
            this.openframe = 0;
        }

        this.add_mouse_event();
    }

    init() {
        this.target.gotoAndStop(0);
        this.childGroup = this.itemControl.getItemsByClassConnect("translatechild", this);
        this.childGroup.forEach(element => {
            element.mainGroup.push(this);
            element.target.gotoAndStop(this.openframe);
            if (this.notFirstFrame) {
                //子物件初始顯示第二影格
                element.isOpen = true;
                this.isOpen = true;
            }
            else {
                element.isOpen = false;
                this.isOpen = false;
            }
        });
    }

    trigger() {
        const self = this;
        let allOpenSucess = true;
        self.childGroup.forEach(element => {
            if (element.isOpen == false) {
                //有答案看不到 在第一影格
                allOpenSucess = false;
                this.isOpen = allOpenSucess;
            }
        });
        if (!allOpenSucess) {
            this.isOpen = false;
        }

        self.childGroup.forEach(element => {
            if (this.isOpen == true) {
                //沒點全開按鈕但實際上答案都打開了
                element.target.gotoAndStop(0); //關閉答案
                element.isOpen = false;
                console.log("沒點全開按鈕但實際上答案都打開了所以關閉答案");
            }
            else if (this.isOpen == false) {
                //打開全部答案
                element.target.gotoAndStop(1); //開啟答案
                element.isOpen = true;
                console.log("打開全部答案");
            }
            element.itemControl.loader.singleAntialiasing(element.target);
        });

        this.isOpen = !this.isOpen;
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.target.gotoAndStop(this.nowBtnIndex);
        });
    }
}